import { render } from "./ApplyImplantHospital.vue?vue&type=template&id=ad982562&scoped=true"
import script from "./ApplyImplantHospital.vue?vue&type=script&lang=js"
export * from "./ApplyImplantHospital.vue?vue&type=script&lang=js"

import "./ApplyImplantHospital.vue?vue&type=style&index=0&id=ad982562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad982562"]])

export default __exports__